// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "8c62a0d-dirty",
    "hash": "8c62a0d",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "8c62a0d-dirty",
    "semverString": null,
    "version": "0.0.1"
};
/* tslint:enable */
